import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_POLICY_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { Policy } from "../generated/graphql";
import { AuthContextProps } from "oidc-react";

export function usePolicy(policyId?: string, memberId?: string, effectiveDate?: string, auth?: AuthContextProps, options?: QueryHookOptions): QueryResult<{ findPolicy: Policy | null }> {
    const user = auth?.userData;
    const signedIn = !!user;
    return useQuery(FIND_POLICY_QUERY, {
        variables: {
            policyId,
            memberId,
            effectiveDate
        },
        skip: !signedIn || policyId?.length !== 7 || memberId?.length !== 9,
        ...options
    });
}
